var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAction({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "10px",
    viewBox: "0 0 7 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2BE9615E-E349-4040-B99A-4BDAAA51E4A4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-2",
    points: "0 0 9 0 9 6 0 6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Action",
    transform: "translate(-575.000000, -1843.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(578.500000, 1848.000000) rotate(270.000000) translate(-578.500000, -1848.000000) translate(574.000000, 1845.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,1.31763132 C8.97369941,1.34105781 8.94573554,1.36285745 8.92130614,1.3883446 C7.47092728,2.90097972 6.02075633,4.4139402 4.57079329,5.92722606 C4.54594807,5.95314703 4.5244294,5.98253859 4.50987572,6 C3.00065838,4.42543654 1.49819811,2.85792271 0,1.29485557 C0.396380059,0.88131304 0.807313805,0.452586674 1.22697976,0.014750009 C2.31060571,1.14529482 3.39838985,2.28028632 4.48991637,3.41907379 C5.57832425,2.28332309 6.66600444,1.1485485 7.76667899,0 C7.81959203,0.0618198908 7.86387682,0.119193088 7.91367123,0.171035031 C8.27512244,0.547702541 8.63771715,0.923285492 9,1.29919381 L9,1.31763132 Z",
    id: "Fill-1",
    fill: "#000000",
    mask: "url(#mask-3)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAction);
export default __webpack_public_path__ + "static/media/Action.965a2981c48fcb2449e5b63969aee916.svg";
export { ForwardRef as ReactComponent };